// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3qJ5C","label":"Category_label__qlEpf","content":"Category_content__32Njm","header":"Category_header__1tGb4","location":"Category_location__3eWgX"};